import { render, staticRenderFns } from "./GHX_PollutionLevel.vue?vue&type=template&id=1bb44f1f&scoped=true&"
import script from "./GHX_PollutionLevel.vue?vue&type=script&lang=js&"
export * from "./GHX_PollutionLevel.vue?vue&type=script&lang=js&"
import style0 from "./GHX_PollutionLevel.vue?vue&type=style&index=0&id=1bb44f1f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb44f1f",
  null
  
)

export default component.exports